import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Dominio } from '../../_models/dominio.model';

@Injectable({
  providedIn: 'root',
})
export class DominioService {
  private apiUrl = `${environment.urlApi}/dominios/`;

  constructor(private http: HttpClient) {}

  getDominio(tipo: string): Observable<Dominio> {
    return this.http
      .get<Dominio>(`${this.apiUrl}/${tipo}`)
      .pipe(
        map((data) => data),
        catchError((error) => {
          console.error(`Error fetching dominio ${tipo}:`, error);
          return throwError(() => new Error(`Error fetching dominio ${tipo}`));
        })
      );
  }
}